import * as React from "react";
type Props = {
  className?: string,
};
function SvgGrainFree({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-GrainFree"
      className={className}
    >
      <g clipPath="url(#clip0_12811_29345)">
        <path
          d="M25.7232 26.9442C25.4601 27.0038 25.1785 20.7974 33.1892 16.4617C33.573 16.2541 34.0096 16.1088 34.477 16.0578C35.7594 15.9178 35.8461 16.5135 35.7443 17.3395C34.9586 23.7176 27.4825 27.8607 25.7232 26.9442ZM25.7232 26.9442L35.4816 16.1941M18.8045 21.3011L14.5788 25.7611M24.7506 14.9896L20.8854 19.0581M32.841 6.33315L27.964 11.5654M11.6172 28.8972L10.7083 29.8315L7.09484 33.7124M15.2095 16.1943L15.1986 33.7125M15.2095 16.1943C9.98106 11.4405 15.2302 6.80295 15.2302 6.80295C20.2126 11.811 15.2095 16.1943 15.2095 16.1943ZM23.7683 29.8914C25.155 29.5677 26.2428 30.2605 26.4752 30.4175C26.8489 30.67 27.6988 31.2441 27.6953 32.0987C27.6922 32.8484 27.0345 33.3767 26.8004 33.5647C25.5386 34.5784 23.2756 34.6743 22.1595 33.4555C20.7251 31.8885 22.2027 30.2569 23.7683 29.8914ZM27.9232 12.0336C30.4818 17.7182 25.7552 17.1249 24.4711 14.4462C22.9293 11.2303 24.3548 3.77619 27.9232 12.0336ZM34.3796 7.58508C31.3799 4.10818 27.1188 1.70166 22.1975 1.12905C11.7744 -0.0832196 2.34184 7.38134 1.12957 17.8018C-0.0853003 28.2248 7.37925 37.6575 17.8023 38.8722C28.2253 40.0846 37.6579 32.62 38.8702 22.1996C39.5125 16.6979 37.7327 11.4696 34.3796 7.58508ZM21.5896 22.6472C21.5896 22.6472 22.2828 29.6172 15.2168 29.5455C15.2168 29.5455 14.5309 22.9292 21.5896 22.6472ZM8.8076 22.6472C8.8076 22.6472 8.11435 29.6172 15.1804 29.5455C15.1804 29.5455 15.8663 22.9292 8.8076 22.6472ZM21.5896 15.1954C21.5896 15.1954 22.2828 22.1654 15.2168 22.0937C15.2168 22.0937 14.5309 15.4774 21.5896 15.1954ZM8.8076 15.1954C8.8076 15.1954 8.11435 22.1654 15.1804 22.0937C15.1804 22.0937 15.8663 15.4774 8.8076 15.1954Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12811_29345">
          <rect width={40} height={40} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgGrainFree;
